import React from 'react'
import { OnSetServicesWrapper } from '../components/onSetServices/styles'
import HeroImage from '../../public/on-set-services/on-set-services-hero.jpg'
import Hero from '../components/Hero'
import LightsCameraGlam from '../components/onSetServices/lightsCameraGlam'
import WhyChecklist from '../components/why-checklist'
import WhyGlamsquadImage from '../../public/on-set-services/why-glamsquad.png'
import ReviewScroll from '../components/review-scroll'
import FAQ from '../faq'
import BookEvent from '../components/book-event'

const OnSetServices = () => {
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/events/contact?origin=on-set'
    }
  }

  const whyHighlights = [
    'Flexible booking with hourly, half-day, and full-day rate options',
    `We'll meet you anywhere in the U.S. (travel fees may apply)`,
    'Easily re-book the same team for future glam needs',
    'White glove service with a dedicated concierge team',
    'Pros are hand-picked based on your vision and glam needs',
  ]

  const reviews = [
    {
      quote: `"The Glamsquad pros have been amazing to work with on set over the years. No matter what city we're in, they ensure the photo shoot process is easy and seamless for us, and we couldn't be happier with the results. We are so appreciative for their work with our models' beautiful hair and makeup looks."`,
      name: 'Alexandra Macon, Over The Moon Founder',
    },
    {
      quote: `"Everyone absolutely adored the artists. They created such a positive, welcoming energy and made our guests feel truly pampered ahead of the beach photoshoot. Not only did they make everyone look beautiful, but the experience itself was such a special part of the day." `,
      name: 'Cocokind',
    },
  ]

  const FAQ_URL =
    'https://help.glamsquad.com/en-US/articles/eventsphotoshoots-47017'

  const FAQ_DATA = [
    {
      id: 1,
      title: 'What services do you provide on set?',
      body: `Glamsquad has vast experience with photoshoots, runway shows, TV appearances, and beyond. We'll work closely with you to customize our on-set beauty services to fit your needs. Please email <a href="mailto:events@glamsquad.com">events@glamsquad.com</a> for more info.`,
    },
    {
      id: 2,
      title: 'Is there a booking minimum for on-set services?',
      body: `On-set services are booked at an hourly rate with a two-hour minimum per service (hair, makeup, or nails). `,
    },
  ]

  return (
    <OnSetServicesWrapper>
      <Hero
        className="hero-component"
        header="ON-SET SERVICES"
        subheader="From brand shoots to TV appearances to runway shows, we'll get your talent camera-ready in a flash."
        buttonTitle="Get Started"
        image={HeroImage}
        ctaClick={handleClick}
        hideCTA={false}
      />
      <LightsCameraGlam {...{ handleClick }} />
      <WhyChecklist
        buttonTitle="Book On-Set Services"
        headerTitle="Why Glamsquad?"
        reasons={whyHighlights}
        image={WhyGlamsquadImage}
        handleClick={handleClick}
      />
      <ReviewScroll reviews={reviews} />
      <div className="faq-wrapper">
        <FAQ data={FAQ_DATA} url={FAQ_URL} />
      </div>
      <BookEvent title="Ready to book on-set services?" {...{ handleClick }} />
    </OnSetServicesWrapper>
  )
}

export default OnSetServices

export const getServerSideProps = async () => {
  return { props: {} }
}
